// Loader.js
import React from 'react';

const Loader = () => (
  <div className="loader-overlay">
    <div className="loader"></div>
  </div>
);

export default Loader;
